import React, { PropTypes } from 'react';

import { NitroAccordion, NitroHeading, NitroButton } from 'nitro-components';

import FeatureList from './FeatureList';

import styled from 'styled-components';

const Wrapper = styled.section`
  position: relative;
`;

const SummaryChangeButton = styled.div`
  position: absolute;
  right: 0;
  top: 0;
`;

const ColourAndExtras = ({ selectedColour, selectedExtras, active, action }) => {
  const colour = [`Colour: ${selectedColour.Value}`];
  const extras = selectedExtras.map(extra => extra.description || extra.Description);

  const list = [...colour, ...extras];

  if (action) {
    return (
      <Wrapper>

        <NitroHeading label="Colour &amp; extras" size="3" />

        <SummaryChangeButton>
          <NitroButton size="compact" label="Edit" action={action} />
        </SummaryChangeButton>

        <FeatureList list={list} />

      </Wrapper>
    );
  }

  if (!list || !list.length) {
    return null;
  }

  return (
    <Wrapper>
      <NitroAccordion title="Colour &amp; extras" details={<FeatureList list={list} />} active={active} />
    </Wrapper>
  );
};

ColourAndExtras.propTypes = {
  action: PropTypes.func,
  selectedColour: PropTypes.object.isRequired,
  selectedExtras: PropTypes.array.isRequired,
  active: PropTypes.bool
};

export default ColourAndExtras;



// WEBPACK FOOTER //
// ./src/features/corporate-quote/components/accordions/ColourAndExtras.js